define([], function() {
	/**
	 * Publish / Subscribe
	 * A event publish/subscribe widget.
	 * @version 2.0.0
	 * @see {@link https://davidwalsh.name/pubsub-javascript}
	 * @exports pubsub
	 */
	var pubsub = (function() {
		var topics = {},
			hOP = topics.hasOwnProperty;

		return {
			subscribe: function(topic, listener) {
				// Create the topic's object if not yet created
				if (!hOP.call(topics, topic)) {
					topics[topic] = [];
				}

				// Add the listener to queue
				var index = topics[topic].push(listener) - 1;

				// Provide handle back for removal of topic
				return {
					remove: function() {
						delete topics[topic][index];
					},
				};
			},
			publish: function(topic, info) {
				// If the topic doesn't exist, or there's no listeners in queue, just leave
				if (!hOP.call(topics, topic)) {
					return;
				}

				// Cycle through topics queue, fire!
				topics[topic].forEach(function(item) {
					item(info !== undefined ? info : {});
				});
			},
		};
	})();

	return pubsub;
});
